export type Burn = {
  totalAmountBurned: string;
  blockTimestamp: string;
};

export type Liquidity = {
  totalAmountLiquidity: string;
  blockTimestamp: string;
};

export enum SelectedTab {
  MAIN,
  FARM,
}
